import { ContactHelpLink } from '@/components/ContactHelpLink';
import { RichTextContent } from '@/components/ui/RichTextContent';
import type { SuccessFeeTermsDocument } from '@fluenceur/types';
import { Text, VStack } from '@chakra-ui/react';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { parseFrozenTerms } from './parse-frozen-terms';

interface FrozenTermsBodyProps {
  document: SuccessFeeTermsDocument | null;
}

/** The frozen text, or an explicit way to reach a human when it cannot be read. */
export const FrozenTermsBody: React.FC<FrozenTermsBodyProps> = ({ document }) => {
  const { t } = useTranslation();
  const body = parseFrozenTerms(document?.content);

  if (!body) {
    return (
      <VStack align="flex-start" gap={2} py={4}>
        <Text color="fg.muted">{t('legal.successFeeTerms.document.unavailable')}</Text>
        <ContactHelpLink />
      </VStack>
    );
  }

  return <RichTextContent data={body.content} />;
};
